import { Component, OnInit } from '@angular/core';
// import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { IsConnectedService } from '@services/is-connected.service';
import AnimationsMethod from '@animations';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import ITicket from '@models/ticket.model';
import { HotToastService } from '@ngneat/hot-toast';
// import { DetailsCureComponent } from './details-cure/details-cure.component';
import { MatDialog } from '@angular/material/dialog';
import { DetailsAchatComponent } from './details-achat/details-achat.component';

@Component({
  selector: 'app-achats',
  templateUrl: './achats.component.html',
  styleUrls: ['./achats.component.scss'],
})
export class AchatsComponent implements OnInit {
  public isConnected: boolean = false;
  public animationsMain: any = AnimationsMethod;
  public tickets: ITicket[] = [];

  constructor(
    // private titleService: Title,
    public isConnectedService: IsConnectedService,
    private router: Router,
    public spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private toast: HotToastService,
    public dialog: MatDialog
  ) {
    // this.titleService.setTitle('Liste de vos achats web / en institut');
    this.isConnected = this.isConnectedService.isConnected;
  }

  ngOnInit(): void {
    if (this.isConnected) {
      this.isConnectedService.updateInformation();
      this.getAllTickets();
    } else {
      this.router.navigate(['/redirect']);
    }
  }

  ngOnDestroy() {
    this.animationsMain = null;
  }

  getAllTickets() {
    this.spinner.show();

    console.log(
      'this.isConnectedService.getDetails()',
      this.isConnectedService.getDetails()
    );
    this.httpClient
      .get(
        'api/v1/software/ticket/all?customerId=' +
          this.isConnectedService.getDetails().user.id
      )
      .subscribe({
        next: (res: any) => {
          this.tickets = res.results;
          setTimeout(() => {
            this.animationsMain();
          }, 50);
        },
        error: (err) => {},
        complete: () => {
          this.spinner.hide();
        },
      });
  }

  downloadPdf(base64String, fileName) {
    const source = `data:application/pdf;base64,${base64String}`;
    const link = document.createElement('a');
    link.href = source;
    link.id = 'zoneDownloadPdf';
    link.download = `${fileName}`;
    link.click();
    document.getElementById('zoneDownloadPdf').remove();
    this.spinner.hide();
  }

  getPdf(ticketId: string) {
    this.spinner.show();
    this.httpClient.get('api/v1/software/ticket/pdf/' + ticketId).subscribe({
      next: (res: any) => {
        if (res.content && res.content !== null) {
          this.downloadPdf(res.content, res.name);
        } else {
          this.toast.error(
            'Une erreur est survenue lors du téléchargement de votre facture. Veuillez recommencer dans quelques instant',
            { position: 'bottom-center' }
          );
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toast.error(
          'Une erreur est survenue lors du téléchargement de votre facture. Veuillez recommencer dans quelques instant',
          { position: 'bottom-center' }
        );
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  detailsTicket(ticket: ITicket) {
    this.dialog.open(DetailsAchatComponent, {
      data: { ...ticket },
      panelClass: 'zalona-modalbox',
      width: '450px',
    });
  }
}
